module.exports = __webpack_public_path__ + "media/images/countrysquared/tw-1c1f4750207a26819528b8bffe3b5ce6.svg";